"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _carFilled = _interopRequireDefault(require("@spothero/icons/car-filled"));
var _lightningBoltFilled = _interopRequireDefault(require("@spothero/icons/lightning-bolt-filled"));
var _arrowsInOut = _interopRequireDefault(require("@spothero/icons/arrows-in-out"));
var _fileSlash = _interopRequireDefault(require("@spothero/icons/file-slash"));
var _mobilePhone = _interopRequireDefault(require("@spothero/icons/mobile-phone"));
var _steeringWheelFilled = _interopRequireDefault(require("@spothero/icons/steering-wheel-filled"));
var _wheelchair = _interopRequireDefault(require("@spothero/icons/wheelchair"));
var _alleyBuildingsFilled = _interopRequireDefault(require("@spothero/icons/alley-buildings-filled"));
var _carDropletsFilled = _interopRequireDefault(require("@spothero/icons/car-droplets-filled"));
var _flameFilled = _interopRequireDefault(require("@spothero/icons/flame-filled"));
var _bus = _interopRequireDefault(require("@spothero/icons/bus"));
var _sparkle = _interopRequireDefault(require("@spothero/icons/sparkle"));
var _keyFilled = _interopRequireDefault(require("@spothero/icons/key-filled"));
var _userPin = _interopRequireDefault(require("@spothero/icons/user-pin"));
var _evChargerFilled = _interopRequireDefault(require("@spothero/icons/ev-charger-filled"));
var _pavedRoad = _interopRequireDefault(require("@spothero/icons/paved-road"));
/**
 * Utilities for working with SpotHero amenities.
 * @module AmenityUtils
 */
const AmenityUtils = {
  /**
   * @namespace
   * @typedef {Object} ICONS - An Object of Amenity icons where key names are the Amenity slug
   * @property {Component} attendant - Icon specific to the name.
   * @property {Component} covered - Icon specific to the name.
   * @property {Component} covered-parking - Icon specific to the name.
   * @property {Component} ev - Icon specific to the name.
   * @property {Component} immediate_parking - Icon specific to the name.
   * @property {Component} immediate-parking - Icon specific to the name.
   * @property {Component} in_out - Icon specific to the name.
   * @property {Component} in-out - Icon specific to the name.
   * @property {Component} no_contract - Icon specific to the name.
   * @property {Component} no-contract - Icon specific to the name.
   * @property {Component} one_tap - Icon specific to the name, identical to "mobile" icon.
   * @property {Component} one-tap - Icon specific to the name, identical to "mobile" icon.
   * @property {Component} paved - Icon specific to the name.
   * @property {Component} self_park - Icon specific to the name.
   * @property {Component} self-park - Icon specific to the name.
   * @property {Component} shuttle - Icon specific to the name.
   * @property {Component} touchless - Icon specific to the name.
   * @property {Component} valet - Icon specific to the name.
   * @property {Component} wheelchair - Icon specific to the name.
   * @property {Component} wheelchair_accessible - Icon specific to the name.
   */
  ICONS: {
    // imports that are used in multiple icons are defined up top temporarily until v1 icons are removed
    // imports with require statements below are the de-facto to avoid unnecessary additional variable creation
    /* eslint-disable camelcase */
    'alley-access': _alleyBuildingsFilled.default,
    'car-wash': _carDropletsFilled.default,
    attendant: _userPin.default,
    // search v2 API version
    covered: _carFilled.default,
    // search v1 API version
    'covered-parking': _carFilled.default,
    ev: _evChargerFilled.default,
    heated: _flameFilled.default,
    // search v2 API version
    immediate_parking: _lightningBoltFilled.default,
    // search v1 API version
    'immediate-parking': _lightningBoltFilled.default,
    // search v2 API version
    in_out: _arrowsInOut.default,
    // search v1 API version
    'in-out': _arrowsInOut.default,
    // search v2 API version
    no_contract: _fileSlash.default,
    // search v1 API version
    'no-contract': _fileSlash.default,
    // search v2 API version
    one_tap: _mobilePhone.default,
    // search v1 API version
    'one-tap': _mobilePhone.default,
    paved: _pavedRoad.default,
    // search v2 API version
    self_park: _steeringWheelFilled.default,
    // search v1 API version
    'self-park': _steeringWheelFilled.default,
    shuttle: _bus.default,
    touchless: _sparkle.default,
    valet: _keyFilled.default,
    wheelchair: _wheelchair.default,
    wheelchair_accessible: _wheelchair.default
    /* eslint-enable camelcase */
  },
  /**
   * Retrieves an amenity icon by its name. Usage requires checking for null and if available, wrapping in JSX brackets.
   * @static
   * @function getIcon
   * @param {String} name - The name of the icon to retrieve.
   * @example
   * const Icon = AmenityUtils.getIcon('ev');
   * {Icon && <Icon className="Foo" />}
   * @returns {ReactElement} - The corresponding amenity React SVG icon component from @spothero/icons.
   */
  getIcon(name) {
    const icon = AmenityUtils.ICONS[name];
    if (!icon) {
      // eslint-disable-next-line no-console
      console.warn(`There is no amenity icon available with the name '${name}'. Add it in fe-utils' AmenityUtils to use it.`);
      return null;
    }
    return icon;
  }
};
var _default = exports.default = AmenityUtils;